import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

const textWrapStyles = `
  hyphens: auto;
  word-break: break-word;
`;

export const StyledMetadataWrapper = styled.div`
  @media print {
    margin-bottom: ${({ theme }) => theme.space.lg};
  }
`;

export const StyledRegimenTitle = styled(Type)`
  line-height: 1.7;
  ${textWrapStyles}
`;

export const StyledCourseTitle = styled(Type)`
  font-style: italic;
  ${textWrapStyles}
`;
